import React from 'react'
import Popup from 'reactjs-popup'
import _ from 'lodash';

export default class PrimaryMenuUserActions extends React.Component {
  constructor(props) {
    super(props);
    this.userIcon = this.userIcon.bind(this)
    this.userActions = this.userActions.bind(this)
  }

  userIcon () {
    if (this.props.current_user.icon != null) {
      return (
        <div className="primary-nav__user-info-image">
          <img src={this.props.current_user.icon} />
        </div>
      )
    }

    return (
      <div className="primary-nav__user-info-image primary-nav__user-info-image--default">
        <i className="lnr lnr-user" />
      </div>
    )
  }

  userActions () {
    if (_.isNil(this.props.current_user)) {
      return (
        <div className="primary-nav__user-info">
          {this.userIcon()}
          <span className="primary-nav__user-info-title">
            Guest User
          </span>
        </div>
      )
    }
    const links = _.map(this.props.links, (link_options, text) => (<a key={text} data-method={link_options.method || 'get'} style={{ color: '#00BAEA' }} className='popup-content__item' href={link_options.href}>{text}</a>))
    const userInfo = popupOpen => (
      <div className="primary-nav__user-info">
        {this.userIcon()}
        <span className="primary-nav__user-info-title">{this.props.current_user.name}</span>
      </div>
    )

    return (
      <Popup
        trigger={(popupOpen) => (userInfo(popupOpen))}
        closeOnDocumentClick
        position='top center'
        arrow={true}
        offsetY={40}
        contentStyle={{ padding: '0', backgroundColor: 'transparent', border: 'none', boxShadow: 'none', borderRadius: null }}
      >
        <div className='popup-content popup-content--text-blue'>
          {links}
          <p>
            Current time zone: {window.currentUserTimezone}
          </p>
        </div>
      </Popup>
    )
  }

  render(){
    return(this.userActions())
  }
}
